import { render } from "./newEnterprise.vue?vue&type=template&id=3f52cede"
import script from "./newEnterprise.vue?vue&type=script&lang=js"
export * from "./newEnterprise.vue?vue&type=script&lang=js"

import "./newEnterprise.vue?vue&type=style&index=0&id=3f52cede&lang=less"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__